import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ currentPage, totalPages, handlePageChange }) {
  const [showFullPages, setShowFullPages] = useState(false);

  const renderPages = () => {
    const pages = [];

    pages.push(1);

    const visibleCount = showFullPages ? 5 : 2;

    for (let i = 2; i <= Math.min(visibleCount, totalPages - 1); i++) {
      pages.push(i);
    }

    if (totalPages > visibleCount + 1) {
      pages.push("ellipsis");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages.map((p, index) => {
      if (p === "ellipsis") {
        return (
          <li key={index}>
            <span className="px-[2px] text-[10px] sm:text-xs">...</span>
          </li>
        );
      }

      return (
        <li key={index}>
          <button
            type="button"
            className={`
              border rounded
              px-1 py-[2px]
              text-[10px] sm:text-sm
              sm:px-2 sm:py-1
              ${currentPage === p ? "bg-[#1f2937] text-white" : ""}
            `}
            onClick={() => handlePageChange(p)}
          >
            {p}
          </button>
        </li>
      );
    });
  };

  return (
    <div className="mt-2 sm:mt-3 flex ">
      <nav>
        <ul
          className="
            inline-flex items-center
            gap-[2px] sm:gap-3
            text-[10px] sm:text-sm
            text-gray-600
          "
        >
          <li>
            <button
              className="
                flex items-center justify-center
                border rounded
                px-[3px] py-[2px]
                sm:px-2 sm:py-1
              "
              type="button"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <ChevronLeft size={12} className="sm:hidden" />
              <ChevronLeft size={18} className="hidden sm:block" />
            </button>
          </li>

          {renderPages()}

          {/* Next */}
          <li>
            <button
              className="
                flex items-center justify-center
                border rounded
                px-[3px] py-[2px]
                sm:px-2 sm:py-1
              "
              type="button"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <ChevronRight size={12} className="sm:hidden" />
              <ChevronRight size={18} className="hidden sm:block" />
            </button>
          </li>

          {/* Expand (Desktop Only) */}
          {totalPages > 5 && (
            <li className="hidden sm:block">
              <button
                onClick={() => setShowFullPages(!showFullPages)}
                className="ml-2 px-2 py-1 border rounded text-sm"
              >
                {showFullPages ? "Compact" : "Expand"}
              </button>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}